
export default function ArtistIntro() {
  const ceoInfo = {
    name: '이길식',
    title: '모래요정 K-Star 샌드아트 대표',
    description: '20년 이상의 경력을 바탕으로 샌드아트의 예술적 가치를 높이고, 고객의 이야기를 감동적으로 전달합니다.',
    careers: [
      '대한민국 샌드아트 자격증 등록',
      '전국 주요 기업 및 공공기관 공연',
      '국내외 샌드아트 페스티벌 초청 작가',
      '샌드아트 전문 강사 양성 프로그램 운영',
      '방송 및 미디어 협업 다수',
    ],
    image: 'https://static.readdy.ai/image/927a1a723ebaeda474e8d5371f15da4e/b617bf41a8e450ade4ae6d5a763c24b0.jpeg'
  };

  const artistInfo = {
    name: '권소연',
    title: '대표 작가',
    description: '섬세한 표현력과 감성적인 스토리텔링으로 관객의 마음을 사로잡는 샌드아트 퍼포먼스를 선보입니다.',
    careers: [
      '국내외 주요 샌드아트 공연 1500회+',
      '기업 행사 / 공공기관 / 학교 전문 퍼포먼스',
      '감성 스토리 중심의 맞춤형 공연 기획',
      '샌드아트 교육 및 체험 프로그램 운영',
      'TV 프로그램 및 광고 출연',
    ],
    educations: [
      '영남대학교 미술학 석사',
    ],
    certifications: [
      '샌드아트 1급',
    ],
    image: 'https://static.readdy.ai/image/927a1a723ebaeda474e8d5371f15da4e/2bb9d210a7fab123e91ddcad70cc172b.jpeg'
  };

  const process = [
    { step: '01', title: '상담', desc: '목적과 메시지 파악' },
    { step: '02', title: '기획', desc: '맞춤 스토리 구성' },
    { step: '03', title: '리허설', desc: '완벽한 사전 준비' },
    { step: '04', title: '공연', desc: '현장 퍼포먼스' },
  ];

  return (
    <section id="artist" className="py-32 lg:py-40 bg-warmWhite">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">

        {/* Section Title */}
        <div className="mb-24 lg:mb-32">
          <p className="text-xs font-medium tracking-widest uppercase text-primary mb-4">Artist</p>
          <h2 className="text-3xl lg:text-5xl font-light text-black leading-tight tracking-tight">
            전문성과 열정으로<br />
            최고의 순간을 만듭니다
          </h2>
        </div>

        {/* CEO Profile */}
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 mb-24 lg:mb-32">
          <div className="lg:col-span-5">
            <div className="aspect-[3/4] overflow-hidden">
              <img
                src={ceoInfo.image}
                alt={`대표 ${ceoInfo.name}`}
                className="w-full h-full object-cover object-top grayscale hover:grayscale-0 transition-all duration-700"
              />
            </div>
          </div>

          <div className="lg:col-span-7 flex flex-col justify-center">
            <div className="mb-10">
              <p className="text-xs font-medium tracking-widest uppercase text-primary mb-3">
                {ceoInfo.title}
              </p>
              <h3 className="text-4xl lg:text-5xl font-light text-black mb-5">{ceoInfo.name}</h3>
              <p className="text-sm text-textGray font-light leading-relaxed max-w-lg">
                {ceoInfo.description}
              </p>
            </div>

            <div className="space-y-3">
              {ceoInfo.careers.map((career, index) => (
                <div key={index} className="flex items-center gap-4">
                  <span className="w-5 h-px bg-primary flex-shrink-0"></span>
                  <span className="text-sm text-textGray font-light leading-snug">{career}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Lead Artist Profile */}
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 mb-24 lg:mb-32">

          {/* Info */}
          <div className="lg:col-span-7 flex flex-col justify-start order-2 lg:order-1">
            <div className="mb-10">
              <p className="text-xs font-medium tracking-widest uppercase text-primary mb-3">
                {artistInfo.title}
              </p>
              <h3 className="text-4xl lg:text-5xl font-light text-black mb-5">{artistInfo.name}</h3>
              <p className="text-sm text-textGray font-light leading-relaxed max-w-lg">
                {artistInfo.description}
              </p>
            </div>

            {/* 주요 경력 */}
            <div className="space-y-3 mb-10">
              {artistInfo.careers.map((career, index) => (
                <div key={index} className="flex items-center gap-4">
                  <span className="w-5 h-px bg-primary flex-shrink-0"></span>
                  <span className="text-sm text-textGray font-light leading-snug">{career}</span>
                </div>
              ))}
            </div>

            {/* 학력사항 + 자격증 나란히 */}
            <div className="grid grid-cols-2 gap-8 mb-10 pt-8 border-t border-lineGray">
              {/* 학력사항 */}
              <div>
                <p className="text-xs font-medium tracking-widest uppercase text-primary mb-4">학력사항</p>
                <div className="space-y-3">
                  {artistInfo.educations.map((edu, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <span className="w-1.5 h-1.5 rounded-full bg-primary flex-shrink-0 mt-1.5"></span>
                      <span className="text-sm text-textGray font-light leading-snug">{edu}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* 자격증 */}
              <div>
                <p className="text-xs font-medium tracking-widest uppercase text-primary mb-4">자격증</p>
                <div className="space-y-3">
                  {artistInfo.certifications.map((cert, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <span className="w-1.5 h-1.5 rounded-full bg-primary flex-shrink-0 mt-1.5"></span>
                      <span className="text-sm text-textGray font-light leading-snug">{cert}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* 경력사항 이미지 */}
            <div className="pt-8 border-t border-lineGray">
              <p className="text-xs font-medium tracking-widest uppercase text-primary mb-4">경력사항</p>
              <div className="grid grid-cols-2 gap-4">
                <div className="w-full aspect-[4/3] overflow-hidden border border-lineGray">
                  <img
                    src="https://public.readdy.ai/ai/img_res/2066a204ec776b40e37c4f50fcecabe7.jpg"
                    alt="경력사항 이미지 1"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="w-full aspect-[4/3] overflow-hidden border border-lineGray">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20award%20or%20career%20achievement%20certificate%20for%20performing%20artist%2C%20elegant%20framed%20diploma%20with%20decorative%20border%2C%20official%20recognition%20document%2C%20clean%20professional%20photography%20on%20light%20neutral%20background&width=600&height=450&seq=career-cert-002&orientation=landscape"
                    alt="경력사항 이미지 2"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Artist Image */}
          <div className="lg:col-span-5 order-1 lg:order-2">
            <div className="aspect-[3/4] overflow-hidden">
              <img
                src={artistInfo.image}
                alt={`${artistInfo.title} ${artistInfo.name}`}
                className="w-full h-full object-cover object-top grayscale hover:grayscale-0 transition-all duration-700"
              />
            </div>
          </div>
        </div>

        {/* Process */}
        <div className="border-t border-lineGray pt-24 lg:pt-32">
          <p className="text-xs font-medium tracking-widest uppercase text-textGray mb-12">Process</p>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
            {process.map((item, index) => (
              <div key={index}>
                <p className="text-5xl lg:text-7xl font-extralight text-lineGray mb-4">{item.step}</p>
                <h4 className="text-lg font-medium text-black mb-2">{item.title}</h4>
                <p className="text-sm text-textGray font-light">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
